import { useState } from 'react';

const faqs = [
  {
    q: '91吃瓜是什么？',
    a: '91吃瓜是一个专注于热点资讯和吃瓜讨论的在线社区平台。我们聚合全网最新、最热的八卦爆料和热点事件，为吃瓜群众提供真实、开放、有趣的互动交流空间。在这里，你可以畅快讨论明星八卦、社会热点、科技财经、体育电竞等各类话题。',
  },
  {
    q: '如何参与91吃瓜的话题讨论？',
    a: '你可以在各话题页面下方直接发表评论，也可以参与热门话题的投票和互动。对于有独家爆料的吃瓜群众，我们提供投稿通道，优质内容将获得首页推荐和流量扶持。所有讨论都遵循社区规范，倡导理性吃瓜、文明互动。',
  },
  {
    q: '91吃瓜的内容来源可靠吗？',
    a: '我们建立了严格的信源核实机制，内容团队会对热点信息进行多方交叉验证。对于未经证实的传闻，我们会明确标注"未核实"状态。同时，社区也鼓励吃瓜群众对可疑信息进行举报，共同维护信息环境的真实性。',
  },
  {
    q: '91吃瓜福利活动怎么参与？',
    a: '我们会定期举办各类吃瓜福利活动，包括话题互动奖励、吃瓜积分兑换、幸运抽奖等。关注首页的"吃瓜福利中心"专区以及社区公告，即可第一时间获取活动信息。参与方式简单，活跃度越高获得福利的几率越大。',
  },
  {
    q: '如何向91吃瓜投稿或爆料？',
    a: '你可以通过投稿邮箱 tougao@91chigua.com 向我们发送独家爆料或优质内容。投稿时请尽量提供详细信息和相关证据，我们的编辑团队会在24小时内审核回复。被采纳的优质投稿将获得首页展示机会。',
  },
  {
    q: '91吃瓜有手机版吗？',
    a: '91吃瓜已全面适配移动端浏览器访问，无需下载安装任何App。只需在手机浏览器中打开我们的网址，即可享受与桌面端一致的内容体验。我们的移动端针对触屏操作进行了专门优化，让你随时随地都能畅快吃瓜。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
            关于91吃瓜的常见疑问，这里都能找到答案
          </p>
          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                >
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 pr-4">
                    {faq.q}
                  </h3>
                  <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line text-foreground-400 text-lg"></i>
                  </span>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIdx === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}